import React, { useState } from "react";
import "@fontsource/almarai";
import "../styles/Showcase.css";

// Composants réutilisables
// Remplace ça
// import { SaveButton, CancelButton, DeleteButton, ValidateButton, DisabledButton } from "../components/reusable/Button/Button";

// Par ça
import Button from "../components/reusable/Forms/Button";
import { SaveButton, CancelButton, DeleteButton, ValidateButton, DisabledButton } from "../components/reusable/Button/PredefinedButtons";
import IconButton from "../components/reusable/Button/IconButton";
import { FaSave, FaTimes, FaTrash, FaCheck } from "react-icons/fa";
import { SaveIconButton, CancelIconButton, DeleteIconButton, EditIconButton, AddIconButton, InfoIconButton, RefreshIconButton, ArrowUpIconButton, ArrowDownIconButton } from "../components/reusable/Button/PredefinedIconButtons";
import SplitButton from "../components/reusable/Button/SplitButton";
import Card from "../components/reusable/Card/Card";
import CardProject from "../components/reusable/Card/CardProject";
import CardUser from "../components/reusable/Card/CardUser";
import TextField from "../components/reusable/Forms/TextField";
import TextArea from "../components/reusable/Forms/TextArea";
import DatePicker from "../components/reusable/Forms/DatePicker";
import RadioGroup from "../components/reusable/Forms/RadioGroup";
import Checkbox from "../components/reusable/Forms/Checkbox";
import Switch from "../components/reusable/Forms/Switch";
import DropdownSimple from "../components/reusable/Dropdown/DropdownSimple";
import DropdownIcones from "../components/reusable/Dropdown/DropdownIcones";
import DropdownMulti from "../components/reusable/Dropdown/DropdownMulti";
import DropdownMenuList from "../components/reusable/Dropdown/DropdownMenuList";
import LoaderButton from "../components/reusable/Loader/LoaderButton";
import LoaderDropdown from "../components/reusable/Loader/LoaderDropdown";
import LoaderAdvanced from "../components/reusable/Loader/LoaderAdvanced";
import TabsNavHorizontal from "../components/reusable/Tab/TabsNavHorizontal";
import TabsNavVertical from "../components/reusable/Tab/TabsNavVertical";
import DatagridSimple from "../components/reusable/Datagrid/DatagridSimple";
import PageHeader from "../components/reusable/ModuleHeader/PageHeader";
import Breadcrumb from "../components/reusable/ModuleHeader/Breadcrumb";
import ToolbarPage from "../components/reusable/ModuleHeader/ToolbarPage";
import KpiSummary from "../components/reusable/Forms/KpiSummary";
import TabsSplitView from "../components/reusable/Navigation/TabsSplitView";
import BadgesSplitView from "../components/reusable/Navigation/BadgesSplitView";
import HeaderSplitView from "../components/reusable/Navigation/HeaderSplitView";
import Tag from "../components/reusable/Information/Tag";
import TagGroup from "../components/reusable/Information/TagGroup";
import InfoPanel from "../components/reusable/Forms/InfoPanel";
import UserAvatar from "../components/reusable/Forms/UserAvatar";
import TextFilter from "../components/reusable/Forms/TextFilter";
import ModalTemplate from "../components/templates/ModalTemplate";
import AssignedUsersMultiSelector from "../components/reusable/Forms/AssignedUsersMultiSelector"; 

const Showcase = () => {
  const [name, setName] = useState("");
  const [error, setError] = useState("");
  const [switchOn, setSwitchOn] = useState(false);
  const [darkMode, setDarkMode] = useState(false);
  const [listStates, setListStates] = useState([true, false, true]);
  const [notificationOn, setNotificationOn] = useState(true);
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedOption2, setSelectedOption2] = useState(null);
  const [selectedOption3, setSelectedOption3] = useState([]);
  const [selectedOption4, setSelectedOption4] = useState([]);
  const [selectedCountries, setSelectedCountries] = useState([]);
  const [description, setDescription] = useState("");
  const [birthDate, setBirthDate] = useState(null);
  const [selectedHorizontal, setSelectedHorizontal] = useState("option1");
  const [selectedVertical, setSelectedVertical] = useState("optionA");
  const [textValue, setTextValue] = useState("");
  const [isArchived, setIsArchived] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);


  const elementsColumns = [
    { header: "ID", accessor: "id" },
    { header: "Nom", accessor: "name" },
    { header: "Type", accessor: "type" },
    { header: "Phase", accessor: "phase" },
  ];

  const elementsData = [
    { id: "E-001", name: "Mur porteur RDC", type: "Wall", phase: "Gros-Œuvre" },
    { id: "E-002", name: "Fenêtre bureau", type: "Window", phase: "Menuiserie" },
    { id: "E-003", name: "Porte coupe-feu", type: "Door", phase: "Menuiserie" },
  ];

  const horizontalOptions = [
    { label: "Option 1", value: "option1" },
    { label: "Option 2", value: "option2" },
    { label: "Option 3", value: "option3" },
  ];

  const verticalOptions = [
    { label: "Option A", value: "optionA" },
    { label: "Option B", value: "optionB" },
    { label: "Option C", value: "optionC" },
  ];

  const splitOptions = [
    { label: "Option 1", onClick: () => alert("Option 1 choisie") },
    { label: "Option 2", onClick: () => alert("Option 2 choisie") },
    { label: "Option 3", onClick: () => alert("Option 3 choisie") },
  ];

  const dropdownIconesOptions = [
    { value: "profil", label: "Profil", icon: "/assets/icones/profil.svg", link: "/profil" },
    { value: "help", label: "Help Support", icon: "/assets/icons/book-open.svg", link: "/profil" },
    { value: "settings", label: "Settings", icon: "/assets/icons/setting.svg", link: "/profil" },
    { value: "about", label: "About", icon: "/assets/icons/info.svg", link: "/profil" },
  ];

  const dropdownMenuItems = [
    { icon: "/assets/icones/profil.svg", label: "Mon profil", link: "/profil" },
    { icon: "/assets/icones/setting.svg", label: "Paramètres", link: "/settings" },
    { icon: "/assets/icones/book-open.svg", label: "Aide", link: "/help" },
    { icon: "/assets/icones/log-out.svg", label: "Déconnexion", link: "/log-out" },
  ];

  const [activeNavHorizontal, setActiveNavHorizontal] = useState(0);
  const [activeNavVertical, setActiveNavVertical] = useState(0);

  const toggleListItem = (index, value) => {
    const updated = [...listStates];
    updated[index] = value;
    setListStates(updated);
  };

  const handleSubmit = () => {
    if (!name) setError("Le nom est requis !");
    else {
      setError("");
      alert(`Bonjour ${name} !`);
    }
  };

  // Onglets pour TabsSplitView
const badgesSplitView = [
  {
    label: "Liste",
    badge: 12,
    content: <p>Affichage de la liste des éléments</p>,
  },
  {
    label: "Détails",
    badge: 3,
    content: <p>Affichage des détails de l'élément sélectionné</p>,
  },
  {
    label: "Historique",
    badge: 8,
    content: <p>Affichage de l'historique des modifications</p>,
  },
];
// Onglets pour le header (HeaderTabs)
const headerSplitView = [
  { label: "Accueil" },
  { label: "Projets" },
  { label: "Équipe" },
  { label: "Paramètres" },
];

const userOptions = [
  { value: "dupont", label: "Jean Dupont" },
  { value: "martin", label: "Sylvie Martin" },
  { value: "diallo", label: "Ali Diallo" },
  { value: "sanchez", label: "Mario Sanchez" },
];

const [assignedUsers, setAssignedUsers] = useState(["dupont"]);

  return (
    <div className="showcase-container">
      <div className="showcase-header">
        <img src="/assets/logos/corelia.png" alt="Quantum Corelia" />
        <h1>Quantum Corelia</h1>
      </div>

      {/* Boutons */}
      <Card title="Boutons">
        <div className="showcase-card-content">
          <Button variant="black">Black</Button>
          <Button variant="white">White</Button>
          <Button variant="grey">Grey</Button>
          <Button variant="caneva">Caneva</Button>
          <Button variant="stream">Stream</Button>
          <Button variant="orbit">Orbit</Button>
          <Button variant="minds">Minds</Button>
          <Button variant="pulse">Pulse</Button>
          <Button variant="disabled" disabled>Disabled</Button>
        </div>
      </Card>

      {/* Boutons prédéfinis */}
      <Card title="Boutons prédéfinis">
        <div className="showcase-card-content">
          <SaveButton onClick={() => alert("Enregistré !")} />
          <CancelButton onClick={() => alert("Annulé !")} />
          <DeleteButton onClick={() => alert("Supprimé !")} />
          <ValidateButton onClick={() => alert("Validé !")} />
          <DisabledButton />
        </div>
      </Card>

      {/* Icon Buttons */}
      <Card title="Icon Buttons">
        <div className="showcase-card-content">
          <IconButton label="Enregistrer" icon={<FaSave />} variant="green" position="left" onClick={() => alert("Enregistrement effectué")} />
          <IconButton label="Annuler" icon={<FaTimes />} variant="gray" position="right" onClick={() => alert("Action annulée")} />
          <IconButton icon={<FaCheck />} variant="blue" position="only" onClick={() => alert("Validé")} />
          <IconButton label="Supprimer" icon={<FaTrash />} variant="red" onClick={() => alert("Supprimé")} />
        </div>
      </Card>

      {/* Icon Buttons prédéfinis */}
      <Card title="Icon Buttons">
        <div className="showcase-card-content">
          <SaveIconButton />
          <CancelIconButton />
          <DeleteIconButton />
          <EditIconButton />
          <AddIconButton />
          <InfoIconButton />
          <RefreshIconButton />
          <ArrowUpIconButton />
          <ArrowDownIconButton />
        </div>
      </Card>

      {/* Split Button */}
      <Card title="Split Button Demo">
        <SplitButton label="Actions" options={splitOptions} onClick={() => alert("Action principale")} />
      </Card>

      {/* Champs texte */}
      <Card title="Champs texte">
        <TextField label="Nom" value={name} onChange={(e) => setName(e.target.value)} placeholder="Entrez votre nom" error={error} />
        <TextArea label="Description" value={description} onChange={(e) => setDescription(e.target.value)} placeholder="Entrez une description..." />
        <Button variant="blue" onClick={handleSubmit}>Valider</Button>
      </Card>

      {/* TextArea */}
      <Card title="TextArea">
        <TextArea value={textValue} onChange={(e) => setTextValue(e.target.value)} rows={5} />
        <p>Contenu saisi : {textValue || "Aucun texte saisi"}</p>
      </Card>

      {/* TextFilter */}
      <Card title="TextFilter">
         <TextFilter
            label="Recherche"           
            placeholder="Entrez le nom ou le lieu du projet"
          /> 
      </Card>

     {/* Template Modal */}
      <Card title="Template Modal" style={{gap:"500px",}}>
        <div className="showcase-card-content">
          <Button variant="blue" onClick={() => setIsModalOpen(true)}>
            Ouvrir le Modal
          </Button>
        </div>
        <ModalTemplate
          isOpen={isModalOpen}
          title="Exemple de Modal Template"
          onClose={() => setIsModalOpen(false)}
          onSubmit={() => {
            alert("Données sauvegardées");
            setIsModalOpen(false);
          }}
        >
          <p>Contenu du modal : champ de test</p>
          <TextField
            label="Nom du projet"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Ex: Projet Alpha"
          />
          <Checkbox
            label="Actif"
            checked={!isArchived}
            onChange={() => setIsArchived(!isArchived)}
          />
        </ModalTemplate>
      </Card>


      {/* Assigned User Selector */}
      <Card title="Assigned User Selector">
        <div style={{ width: 400 }}>
          <AssignedUsersMultiSelector
            label="Personnes assignées"
            values={assignedUsers}
            options={userOptions}
            onChange={setAssignedUsers}
            wrap="nowrap"
            width="100%"
            labelWidth={140}
            height={40}
            zindex={100}
          />
        </div>

      </Card>
      

    {/*abs Horizontales et Verticales */}
      <Card title="Tabs Horizontale" >
        <TabsNavHorizontal labels={[ { label: "Dashboard", icon: "/assets/menus/cog.png" }, { label: "Utilisateurs", icon: "/assets/menus/cube.png" }, { label: "Réglages", icon: "/assets/menus/dashboard-alt.png" }, ]}
          activeIndex={activeNavHorizontal}
          onChange={setActiveNavHorizontal}
          orientation="horizontal"
        />
      </Card>




      <Card title="Tabs Verticales">
        <TabsNavVertical labels={[ { label: "Dashboard", icon: "/assets/menus/cog.png" }, { label: "Utilisateurs", icon: "/assets/menus/cube.png" }, { label: "Réglages", icon: "/assets/menus/dashboard-alt.png" }, ]}
          activeIndex={activeNavVertical}
          onChange={setActiveNavVertical}
          orientation="vertical"
        />
      </Card>
      
      <CardProject
        type="Construction"
        description="Approvisionnement en eau potable"
        projectType="Infrastructure EAP"
        status= ""
        name="Project EPC Wenchi"
        location="Temi, Ghana"
        startDate="01/09/2025"
        endDate="31/12/2025"
        membersCount={8}
        admins={["Alice", "Bob"]}
        progress={65}
      />
      <CardUser
        fullName="Saïd Errazak"
        email="serrazak@hotmail.com"
        role="manager"
      />



      {/* Date Picker */}
      <Card title="Date Picker">
        <DatePicker value={birthDate} onChange={setBirthDate} />
      </Card>

      {/* RadioGroup */}
      <Card title="RadioGroup Horizontal">
        <RadioGroup name="horizontalGroup" options={horizontalOptions} value={selectedHorizontal} onChange={setSelectedHorizontal} orientation="horizontal" className="radio-group horizontal"/>
      </Card>
      <Card title="RadioGroup Vertical">
        <RadioGroup name="verticalGroup" options={verticalOptions} value={selectedVertical} onChange={setSelectedVertical} orientation="vertical" className="radio-group vertical"/>
      </Card>

      {/* Checkbox */}
      <Card title="Checkbox" >
        <div style={{ display: "flex", justifyContent: "flex-start" }}>
          <Checkbox
            label="Archivé"
            checked={isArchived}
            onChange={(v) => setIsArchived(v)}
            disabled={false}
          />
        </div>
      </Card>


      {/* Switch */}
      <Card title="Switch dans une carte">
        <Switch label="Activation" enabled={switchOn} onChange={setSwitchOn} showText={true} size="small" />
      </Card>
      <Card title="Switch dans une barre horizontale">
        <div className="showcase-card-content">
          <Switch label="Dark Mode" enabled={darkMode} onChange={setDarkMode} showText={false} size="medium"/>
          <Switch label="Notifications" enabled={notificationOn} onChange={setNotificationOn} showText={false} size="small"/>
        </div>
      </Card>
      <Card title="Switch dans une liste">
        {listStates.map((state,index)=>(
          <div key={index} className="switch-list-item">
            <span>Élément {index+1}</span>
            <Switch enabled={state} onChange={(val)=>toggleListItem(index,val)} showText={false} size="medium"/>
          </div>
        ))}
      </Card>

      {/* Dropdowns */}
      <Card title="Dropdown Simple">
        <DropdownSimple label="Choisissez une option" placeholder="Sélectionnez..." options={horizontalOptions} value={selectedOption} onChange={setSelectedOption}/>
        <p>Option sélectionnée : {selectedOption || "Aucune"}</p>
      </Card>

      <Card title="Dropdown Icones">
        <DropdownIcones value={selectedOption2} onChange={setSelectedOption2} options={dropdownIconesOptions} placeholder="Mon compte"/>
        <p>Option sélectionnée : {dropdownIconesOptions.find(opt=>opt.value===selectedOption2)?.label || "Aucune"}</p>
      </Card>

      <Card title="Dropdown Avancée">
        <DropdownMulti label="Choisissez plusieurs options" placeholder="Sélectionnez..." options={horizontalOptions} selectedValues={selectedOption3} onChange={setSelectedOption3}/>
        <p>Options sélectionnées : {selectedOption3.join(", ") || "Aucune"}</p>
      </Card>

      <Card title="Dropdown Menu List">
        <DropdownMenuList icon="/assets/icones/home.svg" label="Mon compte" items={dropdownMenuItems}/>
      </Card>

      {/* Loader */}
      <Card title="Loader Button">
        <div className="showcase-card-content">
          <LoaderButton label="Charger les options" onClick={()=>alert("Action déclenchée !")} size="md"/>
          <LoaderButton label="Option désactivée" onClick={()=>{} } disabled size="md"/>
          <LoaderButton label="Petit bouton" onClick={()=>alert("Petit bouton !")} size="sm"/>
        </div>
      </Card>

      <Card title="List Loader">
        <div className="showcase-card-content">
          <LoaderDropdown label="Choisir un pays" options={[{value:"fr",label:"France"},{value:"es",label:"Espagne"},{value:"it",label:"Italie"}]} onSelect={(opt)=>alert(`Vous avez choisi : ${opt.label}`)}/>
          <LoaderDropdown label="Liste vide" options={[]} onSelect={()=>{}} placeholder="Aucune donnée"/>
          <LoaderDropdown label="Bouton désactivé" options={[{value:"fr",label:"France"},{value:"es",label:"Espagne"}]} disabled/>
        </div>
      </Card>

      <Card title="Loader Avancé avec Multi-sélection">
        <LoaderAdvanced label="Choisir des pays" options={[{value:"fr",label:"France"},{value:"es",label:"Espagne"},{value:"it",label:"Italie"},{value:"de",label:"Allemagne"}]} selectedValues={selectedCountries} onChange={setSelectedCountries} showSelectAll={true}/>
      </Card>

      {/* Datagrid */}
      <Card title="Liste des Éléments">
        <DatagridSimple columns={elementsColumns} data={elementsData}/>
      </Card>

      {/* Module Headers */}
      <Card title="PageHeader">
        <PageHeader title="Gestion des Éléments" subtitle="Suivi des composants BIM"/>
      </Card>

      <Card title="Breadcrumb">
        <Breadcrumb items={[{label:"Accueil",href:"/"},{label:"Projets",href:"/projects"},{label:"Éléments",href:"/projects/elements"}]}/>
      </Card>

      <Card title="ToolbarPage">
        <ToolbarPage actions={[{label:"Ajouter",onClick:()=>alert("Ajouter")},{label:"Modifier",onClick:()=>alert("Modifier")},{label:"Supprimer",onClick:()=>alert("Supprimer")}]}/>
      </Card>

      <Card title="KpiSummary">
        <KpiSummary kpis={[{label:"Éléments",value:245},{label:"Incidents",value:12},{label:"Documents",value:84}]}/>
      </Card>

      <Card title="TabsSplitView">
        <TabsSplitView tabs={[{label:"Liste",content:<p>Affichage de la liste</p>},{label:"Détails",content:<p>Affichage des détails</p>},{label:"Historique",content:<p>Affichage de l'historique</p>}]} />
      </Card>
      <Card title="BadgesSplitView">
        <BadgesSplitView tabs={badgesSplitView} />
      </Card>
      <Card title="HeaderSplitView">
        <HeaderSplitView tabs={headerSplitView} />
      </Card>

      {/* Tags et panels */}
      <Card title="Tag">
        <Tag label="Actif" color="#28a745"/>
        <Tag label="En attente" color="#ffc107" textColor="#000"/>
        <Tag label="Archivé" color="#6c757d"/>
      </Card>

      <Card title="TagGroup">
        <TagGroup tags={[{label:"BIM",color:"#007bff"},{label:"En cours",color:"#ffc107",textColor:"#000"},{label:"Validé",color:"#28a745"},{label:"Urgent",color:"#dc3545"}]}/>
      </Card>

      <Card title="TagGroup">
        <TagGroup tags={[
          {label:"To do",color:"#d0e8ff",textColor:"#007bff"},
          {label:"In Progress",color:"#d0ffd6",textColor:"#28a745"},
          {label:"Approved",color:"#f0f0f0",textColor:"#6c757d"},
          {label:"Pending",color:"#ffe0e0",textColor:"#dc3545"},
          {label:"Close",color:"#fffbe0",textColor:"#ffc107"},
        ]}/>
      </Card>
      <Card title="User Avatar">
        <UserAvatar name="Jean Dupont" color="magenta" size={32} />
      </Card>
      <Card title="Panneaux d'information">
        <InfoPanel title="Information générale" message="Ce module vous permet de gérer les documents du projet." variant = "grey" stripPosition = "left"/>
        <InfoPanel title="Information générale" message="Ce module vous permet de gérer les documents du projet." variant = "blue" stripPosition = "right" rounded = {false}/>
        <InfoPanel title="Information générale" message="Ce module vous permet de gérer les documents du projet." variant = "green" stripPosition = "left"/>
        <InfoPanel title="Information générale" message="Ce module vous permet de gérer les documents du projet." variant = "yellow" stripPosition = "left" rounded = {false}/>
        <InfoPanel title="Information générale" message="Ce module vous permet de gérer les documents du projet." variant = "red" stripPosition = "left" rounded = "false"/>
        <InfoPanel title="Information générale" message="Ce module vous permet de gérer les documents du projet." variant = "grey" stripPosition = "left" border = "true" rounded = {false}/>
        <InfoPanel title="Information générale" message="Ce module vous permet de gérer les documents du projet." variant = "blue" stripPosition = "left" border = "true"/>
        <InfoPanel title="Information générale" message="Ce module vous permet de gérer les documents du projet." variant = "green" stripPosition = "left" border = "true" rounded = {false}/>
        <InfoPanel title="Information générale" message="Ce module vous permet de gérer les documents du projet." variant = "yellow" stripPosition = "right" border = "true"/>
        <InfoPanel title="Information générale" message="Ce module vous permet de gérer les documents du projet." variant = "red" stripPosition = "left" border = "true" rounded = {false}/>
      </Card>
    </div>
  );
};

export default Showcase;
